import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import POModal from "../components/poSupplierModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const AddPurchaseOrder = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [priNumber, setPriNumber] = useState(null);  
  const [supplierNo, setSupplierNo] = useState(null);  
const [freight, setFreight] = useState(""); 
const [poNumber, setPoNo] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({yourRefNo: "", yourRefDate: "", ourRefNo: "", ourRefDate: "", transport: "", delMethod: "", delPlace: ""})
const navigate = useNavigate();
const canEntry = hasPermission("Purchase order", "entry");



// Get New Purchase Order Number
useEffect(() => {
  const fetchPoNo = async () => {
    Swal.fire({
      title: "Generating PO Number...",
      html: `<div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
        <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
      </div>`,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        if (!document.getElementById("progressBarStyle")) {
          const style = document.createElement("style");
          style.id = "progressBarStyle";
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchase_no`);
      if (response.data.PoNo) {
        const NewPo = parseInt(response.data.PoNo, 10) || 0;
        setPoNo(NewPo.toString());
        setFormData(prev => ({ ...prev, PoNumber: NewPo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
      Swal.fire("Error", "Failed to fetch PO number.", "error");
    } finally {
      Swal.close();
    }
  };

  {canEntry && (
  fetchPoNo()
  )}
}, []);


// On Item Select (Handles Supplier Items Fetching)
const handleSelectItem = async (supplier) => {
  Swal.fire({
    title: "Loading Supplier Items...",
    html: `<div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
      <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
    </div>`,
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      if (!document.getElementById("progressBarStyle")) {
        const style = document.createElement("style");
        style.id = "progressBarStyle";
        style.innerHTML = `
          @keyframes progressBar {
            0% { width: 0% }
            50% { width: 100% }
            100% { width: 0% }
          }
        `;
        document.head.appendChild(style);
      }
    }
  });

  try {
    setPriNumber(supplier.prDetail_number); 
    setSupplierNo(supplier.prdetail_suppliercode);

    const response = await axios.get("https://rfs2.infraconsoft.net.in/api/getSupplierItems", {
      params: {
        PriNumber: supplier.prDetail_number,
        idsuppliercode: supplier.prdetail_suppliercode,
        branch: branch,
      },
    });

    if (response.data.length > 0) {
      setSelectedItems(response.data);
    }
  } catch (error) {
    console.error("Error fetching supplier items:", error);
    Swal.fire("Error", "Failed to fetch supplier items.", "error");
  } finally {
    Swal.close();
  }
};


// Fetch Freight Charges
useEffect(() => {
  const fetchFreightCharges = async () => {
    if (!priNumber) return;

    Swal.fire({
      title: "Fetching Freight Charges...",
      html: `<div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
        <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
      </div>`,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        if (!document.getElementById("progressBarStyle")) {
          const style = document.createElement("style");
          style.id = "progressBarStyle";
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_fetchFrights?prNo=${priNumber}`);
      const items = response.data.fetchFright;

      if (items.length > 0) {
        setFreight(items[0].freight_charges || '0');
      }

      console.log(items);
    } catch (error) {
      console.error("Error fetching freight charges:", error);
      Swal.fire("Error", "Failed to fetch freight charges.", "error");
    } finally {
      Swal.close();
    }
  };
  {canEntry && (
  fetchFreightCharges()
  )}
}, [priNumber]);


// Fetch Supplier Info
useEffect(() => {
  const fetchSupplierDetails = async () => {
    if (!supplierNo) return;

    Swal.fire({
      title: "Fetching Supplier Details...",
      html: `<div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
        <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
      </div>`,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        if (!document.getElementById("progressBarStyle")) {
          const style = document.createElement("style");
          style.id = "progressBarStyle";
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${supplierNo}`);
      const items = response.data.supDetails;

      if (items && items.length > 0) {
        const storeReqHeader1 = {
          supplierMaster_code: items[0].supplierMaster_code || "N/A",
          supplierMaster_name: items[0].supplierMaster_name || "N/A",
          supplierMaster_addressline1: items[0].supplierMaster_addressline1 || "N/A",
          supplierMaster_addressline2: items[0].supplierMaster_addressline2 || "N/A",
          supplierMaster_city: items[0].supplierMaster_city || "N/A",
          supplierMaster_pincode: items[0].supplierMaster_pincode || "N/A",
        };
        setSubDetails(storeReqHeader1);
      }
    } catch (error) {
      console.error("Error fetching supplier details:", error);
      Swal.fire("Error", "Failed to fetch supplier details.", "error");
    } finally {
      Swal.close();
    }
  };

  {canEntry && (
  fetchSupplierDetails()
  )}
}, [supplierNo]);


  // Calculate totals
  const totals = selectedItems.reduce(
    (acc, item) => {
      const itemValue = item.OrderedQuantity * item.SupplierWIDetail_Price;
      const discountValue = itemValue * (item.SupplierWIDetail_DiscountPercentage / 100);
      const pfValue = itemValue * (item.SupplierWIDetail_PfPercentage / 100);
      const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
      const totalValue = itemValue + taxValue + pfValue - discountValue;

      acc.totalItemValue += itemValue;
      acc.totalDiscValue += discountValue;
      acc.totalTaxValue += taxValue;
      acc.totalPfValue += pfValue;
      acc.grandTotalValue += totalValue ;

      return acc;
    },
    {
      totalItemValue: 0,
      totalDiscValue: 0,
      totalTaxValue: 0,
      totalPfValue: 0,
      grandTotalValue: 0,
    }
  );

  const freightAmount = isNaN(parseFloat(freight)) ? 0.00 : parseFloat(freight);
  const finalTotal = totals.grandTotalValue + freightAmount;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
        Swal.fire("Error", "Please add at least one item", "error");
        return;
    }

      if ((!formData.yourRefNo)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Enter Your Ref No!`,
        });
      return;
      }

       if (Number(!formData.yourRefNo)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Your Ref No should be Number.`,
        });
      return;
      }

        if ((!formData.yourRefDate)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Enter Select our Ref Date!`,
        });
      return;
      }


      if ((!formData.ourRefNo)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Enter our Ref No!`,
        });
      return;
      }

       if (Number(!formData.ourRefNo)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `our Ref No should be Number.`,
        });
      return;
      }

        if ((!formData.ourRefDate)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Enter Select our Ref Date!`,
        });
      return;
      }

        if ((!formData.transport)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Enter Transport!`,
        });
      return;
      }

        if ((!formData.delMethod)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Enter Delivery Method!`,
        });
      return;
      }

       if ((!formData.delPlace)) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty',
          text: `Enter Delivery Place!`,
        });
      return;
      }

if (!formData.priceBasis) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty',
    text: 'Enter Price Basis!',
  });
  return;
}

// ✅ Number validation
if (isNaN(formData.priceBasis)) {
  Swal.fire({
    icon: 'error',
    title: 'Invalid',
    text: 'Price Basis should be a number only!',
  });
  return;
}

    const payload = {
        branch: branch,
        poNumber: formData.PoNumber,
        user: user,
        prNo : priNumber,
        scode: subDetails.supplierMaster_code,
        sName: subDetails.supplierMaster_name,
        sName: subDetails.supplierMaster_name,
        yourRefNo: formData.yourRefNo,
        yourRefDate: formData.yourRefDate,
        ourRefNo: formData.ourRefNo,
        ourRefDate: formData.ourRefDate,
        paymentTerms: formData.paymentTerms,
        transport: formData.transport,
        frightAmt: freight,
        delMethod: formData.delMethod,
        delPlace: formData.delPlace,
        grandTot : finalTotal.toFixed(2),
        remarks: formData.remarks,
        priceBasis: formData.priceBasis,
        // transport: formData.transport,
        subValue : totals.totalItemValue.toFixed(2),
        pfValue: totals.totalPfValue.toFixed(2),
        discValue: totals.totalDiscValue.toFixed(2),
        cst: totals.totalTaxValue.toFixed(2),
        
        items: selectedItems.map((item) => {
            const itemValue = item.OrderedQuantity * item.SupplierWIDetail_Price;
            const discountValue = itemValue * (item.SupplierWIDetail_DiscountPercentage / 100);
            const pfValue = itemValue * (item.SupplierWIDetail_PfPercentage / 100);
            const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
            const totalValue = itemValue + taxValue + pfValue - discountValue;

            return {
                itemCode: item.PrDetail_itemcode,
                itemName: item.itemMaster_Name,
                itemUom: item.itemMaster_purchaseUom,
                orderedQuantity: item.OrderedQuantity,
                price: item.SupplierWIDetail_Price,
                cst: item.SupplierWIDetail_CSTtax,
                pf: item.SupplierWIDetail_PfPercentage,
                disc: item.SupplierWIDetail_DiscountPercentage,
                value: totalValue.toFixed(2), 
                // pfValue: pfValue.toFixed(2), 
                // discValue: discountValue.toFixed(2), 

            };
        }),
    };

    console.log(payload);

    try {
         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/purchase_insert", payload);
        Swal.fire("Success", "Purchase Order added successfully", "success");
        // alert("Success");
        setSelectedItems([]);
        navigate('/inventory/purchaseOrderView');
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};

   if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
            <div className="back-div">
                    <h2 className="add-txt">Add Purchase Order</h2>
                    <Link to='/inventory/purchaseOrderView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>P.O Number :</label>
                <input type="text" name="PoNumber" value={formData.PoNumber} readOnly />
              </div>
              <div className="form-group">
                <label>P.O Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Your Ref No :</label>
                <input type="text" name="yourRefNo" value={formData.yourRefNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Your Ref Date :</label>
                <input type="date" name="yourRefDate" value={formData.yourRefDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Our Ref No :</label>
                <input type="text" name="ourRefNo" value={formData.ourRefNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Our Ref Date :</label>
                <input type="date" name="ourRefDate" value={formData.ourRefDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="address1"value={subDetails.supplierMaster_addressline1} />
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="address2" value={subDetails.supplierMaster_addressline2}/>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="city"value={subDetails.supplierMaster_city} />
              </div>
              <div className="form-group">
                <label>Pin Code :</label>
                <input type="text" name="pincode" value={subDetails.supplierMaster_pincode}/>
              </div>
            </div>


            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>GST%</th>
                    <th>P&F%</th>
                    <th>Disc%</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                      const itemValue = item.OrderedQuantity * item.SupplierWIDetail_Price;
                      const discountValue = itemValue * (item.SupplierWIDetail_DiscountPercentage / 100);
                      const pfValue = itemValue * (item.SupplierWIDetail_PfPercentage / 100);
                      const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.PrDetail_itemcode}</td>
                          <td>{item.itemMaster_Name}</td>
                          <td>{item.itemMaster_purchaseUom}</td>
                          <td>{item.OrderedQuantity}</td>
                          <td>{item.SupplierWIDetail_Price}</td>
                          <td>{item.SupplierWIDetail_CSTtax}</td>
                          <td>{item.SupplierWIDetail_PfPercentage}</td>
                          <td>{item.SupplierWIDetail_DiscountPercentage}</td>
                          <td>{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totalValue)}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* Billing Summary */}
              <div className="po-bill-container">
                <h2 className="po-bill-title">Billing Summary</h2>
                <div className="po-bill-summary">
                  <div className="po-bill-item">
                    <span className="po-bill-label">Sub Total:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalItemValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">GST (%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalTaxValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Disc (%):</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalDiscValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">PF:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(totals.totalPfValue)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Fright Charges:</span>
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(freight)}</span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Transport:</span>
                    <span className="po-bill-value"><input type="text" name="transport" value={formData.transport}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Payment Terms:</span>
                    <span className="po-bill-value"><input type="text" name="paymentTerms" value={formData.paymentTerms}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Delivery Method:</span>
                    <span className="po-bill-value"><input type="text" name="delMethod" value={formData.delMethod}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Delivery Place:</span>
                    <span className="po-bill-value"><input type="text" name="delPlace" value={formData.delPlace}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Price Basis:</span>
                    <span className="po-bill-value"><input type="text" name="priceBasis" value={formData.priceBasis}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item">
                    <span className="po-bill-label">Remarks:</span>
                    <span className="po-bill-value"><input type="text" name="remarks" value={formData.remarks}  onChange={handleChange}/></span>
                  </div>
                  <div className="po-bill-item po-bill-total">
                    <span className="po-bill-label">Total:</span>
                    
                    <span className="po-bill-value">₹{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(finalTotal)}</span>
                  </div>

                </div>
              </div>


            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <POModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddPurchaseOrder;
